<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardHeader>
          <strong>User</strong>
        </CCardHeader>
        <CCardBody :items="this.item">
          <CForm @submit.prevent="atualizarUser" id="form">
            <CRow>
              <CCol col=12>
                <CAlert
                  :show.sync="dismissCountDown"
                  closeButton
                  color="danger"
                  fade
                >
                  {{errorMsg}}
                </CAlert>
              </CCol>
              <CCol col=6>
                <CInput
                  label="User Name"
                  v-model="item.username"
                  :value="this.item.username"
                  bottom
                  required
                />
              </CCol>

              <CCol col=6>
                <CInput
                  label="E-mail"
                  v-model="item.email"
                  :value="this.item.email"
                  bottom
                  type="email"
                  required
                />
              </CCol>

              <CCol col=6>
                <CInput
                  v-model="item.password"
                  :value="this.item.password"
                  label="Password"
                  bottom
                  type="password"
                  required
                />
              </CCol>
              

              <CCol col=6>
                <div role="group" class="form-group">
                  <label for="_safe_id_i81sh75grp" class=""> Role </label>
                  <select name="LeaveType" v-model="item.roles" v-bind:value="this.item.roles" class="form-control">
                      <option value="">Select role</option>
                      <option value="admin">Admin</option>
                      <option value="moderator">Moderator</option>
                  </select>
                </div>

                
              </CCol>

              <CCol col="12" class="text-center">
                <CButton size="sm" color="warning" @click="goBack()" style="margin-right: 10px;">Back</CButton>

                <CButton size="sm" color="danger" @click="deleteUser($route.params.id)" style="margin-right: 10px;">Delete</CButton>

                <CButton type="submit" size="sm" color="primary">Save</CButton>
              </CCol>
            </CRow>
            
            
          </CForm>
        </CCardBody>
        
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Users from "@/services/UserDataService";
export default {
  name: 'User',
  data: () => {
    return {
      item: '',
      id: 0,
      options: ['admin', 'moderator'],
      dismissCountDown: 0,
      errorMsg: ''
    }
  },
  mounted () {
    if (!this.currentUser) {
      this.$router.push('/login');
    }
    this.id = this.$route.params.id
    
    this.getUserData();
    
  },
  methods: {
    atualizarUser(){
      Users.updateUser(this.id,this.item.username, this.item.email, this.item.password, this.item.roles).then(response => {
        
        if(response.data == 'ok'){
          let message = {
            status: 'success',
            text: '<strong>Usuário atualizado</strong>'
          }
          EventBus.$emit('showMessage', message);
          this.$router.push('/users');
        }else{
          this.errorMsg = response.data.message;
          this.dismissCountDown = '10';
        }
        return false
      })
      .catch(e => {
        alert(e);
      });
      return false
    },
    deleteUser(id){
      Users.delete(id).then(response => {

        if(response.data =='ok'){
          let message = {
            status: 'success',
            text: '<strong>Usuário removido</strong>'
          }
          EventBus.$emit('showMessage', message);
          this.$router.push('/users');
        }

      })
      .catch(e => {
        alert(e);
      });
    },
    getUserData () {
      
      Users.get(this.id)
        .then(response => {

          this.item = response.data;

        })
        .catch(e => {
          alert(e);
        });
    },
    goBack() {
      this.$router.push('/users');
    }
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_MODERATOR');
      }

      return false;
    },
    showAdminOrModeratorBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_MODERATOR') || this.currentUser.roles.includes('ROLE_ADMIN');
      }

      return false;
    },
  }
}
</script>
